import { resourceSliceFactory } from "infrastructure/store/state";
import type { PspKycSettingsState } from "./types";

const state: PspKycSettingsState = {
    settings: resourceSliceFactory()
};

export const sliceToken = 'pspKycSettings';

export default state;
